import { DatePicker, Select, Typography } from 'antd';
import moment from 'moment';
import { IBestDataset } from '../../../../../types/analytics';
import { DateFormat } from '../../../../../utils/StaticVariable';
import styles from '../../../Analytics/components/Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface ReportsInputFormProps {
  datasets: IBestDataset[];
  datasetSW: string;
  datasetHD: string;
  datasetWind: string;
  onSelectDataset: (type: 'SW' | 'HD' | 'Wind') => (value: string) => void;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  onStartDateChange: (date: any) => void;
  onEndDateChange: (date: any) => void;
  disabledStartDate: (date: any) => boolean;
  disabledEndDate: (date: any) => boolean;
  isOfflineDataset: boolean;
  timeStep: string;
}

export default function ReportsInputForm({
  datasets,
  datasetSW,
  datasetHD,
  datasetWind,
  onSelectDataset,
  timeStep,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabledStartDate,
  disabledEndDate,
  isOfflineDataset,
}: ReportsInputFormProps) {
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Waves</Text>
        <Select
          id='Reports-Dataset_Waves_Input'
          value={datasetSW || '-'}
          onChange={onSelectDataset('SW')}
          placeholder='Select dataset'
          disabled={isOfflineDataset}
        >
          <Select.Option value='none'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Waves')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Ocean</Text>
        <Select
          id='Reports-Dataset_Ocean_Input'
          value={datasetHD || '-'}
          onChange={onSelectDataset('HD')}
          placeholder='Select dataset'
          disabled={isOfflineDataset}
        >
          <Select.Option value='none'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Ocean')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Atmosphere</Text>
        <Select
          id='Reports-Dataset_Atmosphere_Input'
          value={datasetWind || '-'}
          onChange={onSelectDataset('Wind')}
          placeholder='Select dataset'
          disabled={isOfflineDataset}
        >
          <Select.Option value='none'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Atmosphere')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
      </div>

      <div
        className={`${styles.formItem} ${styles.dateItem}`}
        data-testid='Reports-StartDate_Input'
      >
        <Text>Start Date</Text>
        <DatePicker
          value={moment(startDate)}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
          disabled={isOfflineDataset}
        />
      </div>

      <div
        className={`${styles.formItem} ${styles.dateItem}`}
        data-testid='Reports-EndDate_Input'
      >
        <Text>End Date</Text>
        <DatePicker
          value={moment(endDate)}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
          disabled={isOfflineDataset}
        />
      </div>

      <div className={`${styles.formItem} ${styles.dateItem}`}>
        <Text>Time Step</Text>
        <Select
          id='Reports-TimeStep_Input'
          value={timeStep}
          placeholder='Select dataset'
          disabled={true}
        ></Select>
      </div>
    </div>
  );
}
